import { Visibility } from '@material-ui/icons';
import './widgetsm.scss';

export default function WidgetSm() {
  return <div className='widgetsm'>
    <span className="title">New Join Members</span>
    <ul className="list">
      <li className="list-item">
        <img src="https://i.pinimg.com/474x/91/27/a5/9127a595d3a3421d984edc45230f6d9a.jpg" alt="" />
        <div className="user">
          <span className="username">Ankit Pal</span>
          <span className="user-title">Software Engineer</span>
        </div>
        <button className="widget-sm-button">
          <Visibility />
          <span>Display</span> 
        </button>
      </li>
      <li className="list-item">
        <img src="https://i.pinimg.com/474x/91/27/a5/9127a595d3a3421d984edc45230f6d9a.jpg" alt="" />
        <div className="user">
          <span className="username">Ankit Pal</span>
          <span className="user-title">Software Engineer</span>
        </div>
        <button className="widget-sm-button">
          <Visibility />
          <span>Display</span> 
        </button>
      </li>
      <li className="list-item">
        <img src="https://i.pinimg.com/474x/91/27/a5/9127a595d3a3421d984edc45230f6d9a.jpg" alt="" />
        <div className="user">
          <span className="username">Ankit Pal</span>
          <span className="user-title">Software Engineer</span>
        </div>
        <button className="widget-sm-button">
          <Visibility />
          <span>Display</span> 
        </button>
      </li>
      <li className="list-item">
        <img src="https://i.pinimg.com/474x/91/27/a5/9127a595d3a3421d984edc45230f6d9a.jpg" alt="" />
        <div className="user">
          <span className="username">Ankit Pal</span>
          <span className="user-title">Software Engineer</span>
        </div>
        <button className="widget-sm-button">
          <Visibility />
          <span>Display</span> 
        </button>
      </li>
      <li className="list-item">
        <img src="https://i.pinimg.com/474x/91/27/a5/9127a595d3a3421d984edc45230f6d9a.jpg" alt="" />
        <div className="user">
          <span className="username">Ankit Pal</span>
          <span className="user-title">Spftware Engineer</span>
        </div>
        <button className="widget-sm-button">
          <Visibility />
          <span>Display</span> 
        </button>
      </li>
      <li className="list-item">
        <img src="https://i.pinimg.com/474x/91/27/a5/9127a595d3a3421d984edc45230f6d9a.jpg" alt="" />
        <div className="user">
          <span className="username">Ankit Pal</span>
          <span className="user-title">Software Engineer</span>
        </div>
        <button className="widget-sm-button">
          <Visibility />
          Display  
        </button>
      </li>
    </ul>
  </div>;
}
